import React from "react";
import Slider from "react-slick";
import Heading from "../../shared/headings";
import Paragraph from "../../shared/paragraphs";
import { iniciativasDatasSlide, settings } from "./mock";
import {
  AboutInciativas,
  CarouselContainer,
  Container,
  FirstSection,
  SecondSection,
  SlideContent,
} from "./styles";

function Iniciativas() {
  return (
    <>
      <Container>
        <AboutInciativas>
          <Heading text="Iniciativas" size="h2" />
          <Paragraph
            text="O que move o Circuito Inclusão
                a educar é o desejo de divulgar 
                a importância do lazer na vida das pessoas, 
                disseminar conhecimento sobre as possibilidades 
                de práticas e construções sociais inclusivas e 
                estabelecer momentos de lazer possíveis 
                às pessoas com deficiência e suas famílias."
            type="P2"
          />
        </AboutInciativas>
        <CarouselContainer>
          <Slider {...settings}>
            {iniciativasDatasSlide.map(
              ({ title, image, information, informationList }, index) => (
                <SlideContent key={index}>
                  <FirstSection>
                    <Heading text={title} size="h3" />
                    <Paragraph text={information} type="P2" />
                    {informationList.title ? (
                      <ul>
                        <Heading text={informationList?.title} size="h4" />
                        {informationList?.listItems?.map((item) => (
                          <li key={item}>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </FirstSection>
                  <SecondSection>
                    <img {...image} alt={image.alt} />
                  </SecondSection>
                </SlideContent>
              )
            )}
          </Slider>
        </CarouselContainer>
      </Container>
    </>
  );
}

export default Iniciativas;
